import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import "./style.less";
import { camelCase } from "lodash/string";
import { Tooltip } from "@material-ui/core";

export const Switch = props => {
	const {
		className,
		labelText,
		fieldKey,
		isChecked,
		obj,
		onChangeValues,
		row,
		isInAddMode,
		disabled,
		toolTip,
		isInline = false
	} = props;
	let switchClass = className;
	const id = camelCase(props.id);

	if (props.large === true) {
		switchClass += " switch--large";
	} else {
		switchClass += " switch--small";
	}
	if (props.noText === true) {
		switchClass += " switch--no-text";
	}
	if (props.theme === "success") {
		switchClass += " switch--success";
	}
	return (
		<div className={cx("switch-btn-container", isInline && "inline-btn")}>
			<div className={"switch__outer__label"}>{labelText}</div>
			{toolTip !== undefined ? (
				<Tooltip title={toolTip}>
					<div aria-label={id} className={switchClass}>
						<label className={"switch__label"} htmlFor={id}>
							<input
								name={id}
								role={"switch"}
								type={"checkbox"}
								defaultChecked={isChecked}
								disabled={disabled}
								onClick={e =>
									onChangeValues(
										e.target.checked,
										fieldKey,
										row,
										isInAddMode,
										obj
									)}
								value={isChecked}
								className={"switch__input"}
								id={id}
							/>
							<span className={"switch__text"} data-on={"Yes"} data-off={"No"} />
							<span className={"switch__handle"} />
						</label>
					</div>
				</Tooltip>
			) : (
				<div aria-label={id} className={switchClass}>
					<label className={"switch__label"} htmlFor={id}>
						<input
							name={id}
							role={"switch"}
							type={"checkbox"}
							defaultChecked={isChecked}
							disabled={disabled}
							onClick={e =>
								onChangeValues(
									e.target.checked,
									fieldKey,
									row,
									isInAddMode,
									obj
								)}
							value={isChecked}
							className={"switch__input"}
							id={id}
						/>
						<span className={"switch__text"} data-on={"Yes"} data-off={"No"} />
						<span className={"switch__handle"} />
					</label>
				</div>
			)}
		</div>
	);
};

Switch.propTypes = {
	className: PropTypes.string,
	theme: PropTypes.string,
	label: PropTypes.string,
	isChecked: PropTypes.bool
};

Switch.defaultProps = {
	className: "switch",
	noText: false,
	isChecked: false
};
